import { forwardStyledComponentRef } from '@shared/utils/forwardRef';
import React from 'react';
import type { ButtonV2Props } from '../ButtonV2';
import { ButtonV2 } from '../ButtonV2';

export interface CancelButtonProps extends Readonly<Omit<ButtonV2Props, 'intent' | 'variant' | 'shape'>> {}

export const CancelButton = forwardStyledComponentRef<'button', CancelButtonProps>((props, ref) => {
  return (
    <ButtonV2
      {...props}
      color="black"
      intent="primary"
      variant="ghost"
      ref={ref}
    />
  );
});
